import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { message, Card, Form, Input, Button, Space, Select } from 'antd';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

export default function EditPost({ posts = [], onEditPost, loggedInUser, allTags = [] }) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [post, setPost] = useState(null);
  const [title, setTitle] = useState('');
  const [summary, setSummary] = useState('');
  const [tags, setTags] = useState([]);
  const [content, setContent] = useState('');
  const [preview, setPreview] = useState(false);

  useEffect(() => {
    const p = posts.find((x) => x.id === id);
    setPost(p || null);
    if (p) {
      setTitle(p.title);
      setSummary(p.summary || '');
      setTags(p.tags || []);
      setContent(p.content);
    }
  }, [id, posts]);

  function handleSave() {
    if (!post) return;
    if (!loggedInUser || loggedInUser.id !== post.authorId) {
      message.error('只有作者本人可以编辑文章');
      return;
    }
    const ok = onEditPost(post.id, title, summary, tags, content);
    if (ok) navigate('/');
  }

  if (!post) {
    return <div>未找到文章。</div>;
  }

  return (
    <Card title={`编辑：${post.title}`}>
      <Form layout="vertical" onFinish={handleSave}>
        <Form.Item label="标题" required>
          <Input value={title} onChange={(e) => setTitle(e.target.value)} />
        </Form.Item>

        <Form.Item label="文章摘要" required>
          <Input.TextArea rows={3} value={summary} onChange={(e) => setSummary(e.target.value)} />
        </Form.Item>

        <Form.Item label="标签">
          <Select
            mode="tags"
            style={{ width: '100%' }}
            value={tags}
            onChange={(v) => setTags(v)}
            placeholder="输入并回车创建标签"
            options={(typeof allTags !== 'undefined' ? allTags : []).map((t) => ({ label: t, value: t }))}
          />
        </Form.Item>

        <Form.Item label="内容 (支持 Markdown)" required>
          <Input.TextArea rows={12} value={content} onChange={(e) => setContent(e.target.value)} />
        </Form.Item>

        <Form.Item>
          <Space>
            <Button type="primary" htmlType="submit">保存</Button>
            <Button onClick={() => setPreview((p) => !p)}>{preview ? '隐藏预览' : '显示预览'}</Button>
            <Button onClick={() => navigate(-1)}>取消</Button>
          </Space>
        </Form.Item>
      </Form>

      {preview && (
        <Card size="small" title="预览" style={{ marginTop: 12 }}>
          <ReactMarkdown remarkPlugins={[remarkGfm]}>{content || '*空内容*'}</ReactMarkdown>
        </Card>
      )}
    </Card>
  );
}
